import styled from "styled-components";

export const FooterStyle = styled.footer`
 width: 480px;
 margin: auto;
 p {
  margin: 10px 0;
 }
 a {
  text-decoration: underline;
 }
`;
